import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import ErrorBoundary from "./ErrorBoundary";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { REACT_APP_SITE_NAME } from "../config";
import { redirect } from "../redux/actions/common.actions";
import Home from "./Home";
import Thank from "./Thank";
import Locate from "./Locate";
import Welcome from "./Welcome";
import HelpIphone from "./Help-Iphone";
import HelpAndroid from "./Help-Android";

function App() {
  const common = useSelector(state => state.common);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (common.redirectTo) {
      history.push(common.redirectTo);
      dispatch(redirect());
    }
  }, [common]);

  return (
    <div id="site-wrap">
      <Helmet>
        <title>{REACT_APP_SITE_NAME}</title>
      </Helmet>
      <ErrorBoundary>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/home" component={Home} />
          <Route path="/thank" component={Thank} />
          <Route path="/help-iphone" component={HelpIphone} />
          <Route path="/help-android" component={HelpAndroid} />
          <Route path="/:key/locate" component={Locate} />
          <Route path="/:key" component={Welcome} />
          <Redirect from="*" to="/" />
        </Switch>
      </ErrorBoundary>
    </div>
  );
}

export default App;
